import { gql } from "apollo-boost";

export const GET_INVOICES = gql`
  query Invoices(
    $where: InvoiceWhereInput
    $orderBy: OrderByInput
    $skip: Int
    $limit: Int
  ) {
    invoices(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        invoiceNubmer
        totalMoney
        status
        percent
        shopName
        invoiceType
        shop {
          id
          name
          phone
          image
        }
        orderGroups {
          id
          amount
          sumPriceBaht
          sumPriceUsd
          sumPrice
          code
          createdAt
          customerName
          phone
          address
          totalPrice
          infulancer_percent
        }
        note
        createdAt
        updatedAt
      }
    }
  }
`;
